/**
 * Created by luka on 23.02.2018.
 */
import {get} from "../utils/api";
import {
    AD,
    BET_MODE,
    DAYS_FETCH_DATA_SUCCESS,
    DAYS_LOADING,
    EXTEND_OR_PAYOUT,
    INITIAL_ORDER,
    INVITES,
    LINK,
    LOADING_DAYS_FAILED,
    MONTHLY_TOTAL,
    NEW_VERSION,
    NEXT_PAYOUT,
    OFFER_PAYOUT,
    OPEN_DAYS,
    PERIOD,
    PERIOD_BEGIN,
    POST_ID,
    RETRY,
    SHOW_INVITE_FRIENDS,
    SUCCESSFUL_MONTHS,
    USER_ON_TRACK
} from "../actions/types";
import {ACCOUNT_DISABLED, INVALID_TOKEN, LEVEL_NOT_SET, USER_NOT_FOUND} from "../utils/constants";
import {resetNavigationToLevel, navigationToDisabled} from "../navigation/NavigationActions";
import {logout, userLoggedIn} from "../login/LoginAction";
import {getUserSync, saveUser} from "../utils/auth";
import {clearWorkout} from "../utils/workoutStore";
import {APP_VERSION_CODE, APP_VERSION_NAME} from "../utils/version";


export function loadingDaysFailed(error) {
    return {
        type: LOADING_DAYS_FAILED,
        error
    };
}

export function daysLoading(bool) {
    return {
        type: DAYS_LOADING,
        isLoading: bool
    };
}

export function daysFetchDataSuccess(days) {
    return {
        type: DAYS_FETCH_DATA_SUCCESS,
        days
    };
}

export function monthlyTotal(monthlyTotal) {
    return {
        type: MONTHLY_TOTAL,
        monthlyTotal: monthlyTotal
    };
}

export function openDays(openDays) {
    return {
        type: OPEN_DAYS,
        openDays: openDays
    };
}

export function initialOrder(initialOrder) {
    return {
        type: INITIAL_ORDER,
        initialOrder: initialOrder
    };
}

export function userInvites(invites) {
    return {
        type: INVITES,
        invites
    };
}

export function newVersion(boolean) {
    return {
        type: NEW_VERSION,
        newVersion: boolean
    };
}

export function userOnTrack(boolean) {
    return {
        type: USER_ON_TRACK,
        userOnTrack: boolean
    };
}

export function offerPayout(boolean) {
    return {
        type: OFFER_PAYOUT,
        offerPayout: boolean
    };
}

export function retry(boolean) {
    return {
        type: RETRY,
        retry: boolean
    };
}

export function nextPayout(nextPayout) {
    return {
        type: NEXT_PAYOUT,
        nextPayout: nextPayout
    };
}

export function successfulMonths(successfulMonths) {
    return {
        type: SUCCESSFUL_MONTHS,
        successfulMonths: successfulMonths
    };
}


export function periodBegin(periodBegin) {
    return {
        type: PERIOD_BEGIN,
        periodBegin: periodBegin
    };
}

export function period(period) {
    return {
        type: PERIOD,
        period: period
    };
}



export function showInviteFriends(boolean) {
    return {
        type: SHOW_INVITE_FRIENDS,
        showInviteFriends: boolean
    };
}

export function extendOrPayout(isAllowed) {
    return {
        type: EXTEND_OR_PAYOUT,
        isAllowed: isAllowed
    };
}

export function betMode(betMode) {
    return {
        type: BET_MODE,
        betMode: betMode
    };
}


export function postId(postId) {
    return {
        type: POST_ID,
        postId: postId
    };
}

export function link(link) {
    return {
        type: LINK,
        link: link
    };
}

export function ad(ad) {
    return {
        type: AD,
        ad: ad
    };
}

export function daysFetchData() {
    return (dispatch) => {
        dispatch(daysLoading(true));

        get('days')
            .then((daysResponse) => {
                if (daysResponse.msg === USER_NOT_FOUND || daysResponse.msg === INVALID_TOKEN) {
                    dispatch(logout());
                } else {
                    if (daysResponse.msg === ACCOUNT_DISABLED) {
                        dispatch(navigationToDisabled());
                    } else {
                        if (daysResponse.msg === LEVEL_NOT_SET) {
                            dispatch(resetNavigationToLevel());
                        }

                        if (daysResponse.ok) {
                            dispatch(extendOrPayout(daysResponse.payout_or_extend));
                        }
                        if(daysResponse.offer_payout != null){
                            dispatch(offerPayout(daysResponse.offer_payout));
                        }
                        if(daysResponse.retry != null) {
                            dispatch(retry(daysResponse.retry));
                        }

                        if(daysResponse.next_payout != null) {
                            dispatch(nextPayout(daysResponse.next_payout));
                        }

                        if(daysResponse.period_begin != null) {
                            dispatch(periodBegin(daysResponse.period_begin));
                        }

                        if(daysResponse.period != null) {
                            dispatch(period(daysResponse.period));
                        }

                        if(daysResponse.successful_months != null) {
                            dispatch(successfulMonths(daysResponse.successful_months));
                        }

                        if(daysResponse.ad != null){
                            dispatch(link(daysResponse.ad.link));
                            dispatch(ad(daysResponse.ad));
                        }

                        if(daysResponse.level != null) {
                            const currentUser = getUserSync();
                            if(currentUser.level != daysResponse.level){
                                clearWorkout();
                            }
                            currentUser.level = daysResponse.level;
                            dispatch(userLoggedIn(currentUser));
                            saveUser(currentUser)
                        }

                        dispatch(showInviteFriends(daysResponse.showInvite));
                        dispatch(showInviteFriends(daysResponse.showInvite));
                        dispatch(showInviteFriends(daysResponse.showInvite));

                        dispatch(showInviteFriends(daysResponse.showInvite));
                        dispatch(daysFetchDataSuccess(daysResponse.days));
                        dispatch(monthlyTotal(daysResponse.monthly_total));
                        dispatch(openDays(daysResponse.open_days));
                        dispatch(initialOrder(daysResponse.initial_order));
                        if (daysResponse.initial_order.bet_mode) {
                            dispatch(betMode(daysResponse.initial_order.bet_mode));
                        } else {
                            dispatch(betMode(0));
                        }
                        dispatch(userInvites(daysResponse.invites));
                        dispatch(userOnTrack(daysResponse.on_track));

                        if(APP_VERSION_CODE !== daysResponse.version.minimum_version_code && daysResponse.version.force_update){
                            dispatch(newVersion(true));
                        }else{
                            dispatch(newVersion(false));
                        }
                    }
                    dispatch(daysLoading(false));
                }
            })

            .catch((error) => {
                console.log(error);
                dispatch(loadingDaysFailed(error));
                dispatch(daysLoading(false));
            });
    };
}


// WEBPACK FOOTER //
// ./src/overview/OverviewAction.js